import { render, staticRenderFns } from "./deleteGroupBuyProduct.vue?vue&type=template&id=0b3e4587&scoped=true"
import script from "./deleteGroupBuyProduct.vue?vue&type=script&lang=js"
export * from "./deleteGroupBuyProduct.vue?vue&type=script&lang=js"
import style0 from "./deleteGroupBuyProduct.vue?vue&type=style&index=0&id=0b3e4587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e4587",
  null
  
)

export default component.exports